import { render, staticRenderFns } from "./NoteEditorFilterMenu.vue?vue&type=template&id=357132bc&scoped=true&"
import script from "./NoteEditorFilterMenu.vue?vue&type=script&lang=js&"
export * from "./NoteEditorFilterMenu.vue?vue&type=script&lang=js&"
import style0 from "./NoteEditorFilterMenu.vue?vue&type=style&index=0&id=357132bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357132bc",
  null
  
)

export default component.exports